<template>
  <div>
    <router-view @setAppClasses="$emit('setAppClasses', $event)" />
    <socket-setup />
  </div>
</template>

<script>
import SocketSetup from './SocketSetup.vue';

export default {
  components: { SocketSetup },
  name: 'App',
};
</script>
